import React, { useEffect, useRef, useState } from "react";
import AddLeadsDetails from "./AddLeadsDetails";
import {
  Button,
  Grid,
  Typography,
  Card,
  CardContent,
  CardActions,
  Box,
  Container,
  Stack,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Switch,
  OutlinedInput,
  IconButton,
} from "@mui/material";
import MessagePopup from "../common/MessagePopUp";
import SideBarMenuItems from "../SideBarMenuItems";
import Loader from "../common/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  LeadDetailsPage,
  LoginPage,
  OverviewPage,
} from "../../core/PageConstants";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import UserHelper from "../../core/UserHelper";
import {
  BusinessCategories,
  ConfirmTypes,
  LeadStatus,
  MaxDateLimit,
  SideBarMenuNames,
  UserRoles,
} from "../../core/Constants";
import { addMonths } from "date-fns";
import Utils from "../../core/Utils";
import { postAsync } from "../../core/serviceClient";
import { getBusiness, getCountry } from "../../data/localSettingsActions";
import CountryHelper from "../../core/CountryHelper";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import moment from "moment";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import { connectToStore } from "../../data/store";
import BusinessHelper from "../../core/BusinessHelper";
import { Chip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as XLSX from "xlsx";
import DownloadIcon from "@mui/icons-material/Download";
import ErrorTableDialog from "../common/ErrorTableDialog";
import { ConfirmDialog } from "../common/ConfirmDialog";

const LeadDetails = () => {
  document.title = "Lead Details";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [msgOpen, setMsgOpen] = useState(false);
  const [msgText, setMsgText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showLeadModal, setShowLeadModal] = useState(false);
  const [isNavigateToLogin, setIsNavigateToLogin] = useState(false);
  const [leadList, setLeadList] = useState([]);
  const [editingLeadIndex, setEditingLeadIndex] = useState(null);
  const [editingLeadData, setEditingLeadData] = useState(null);
  const [selectedDate, setSelectedDate] = useState([
    Utils.GetStartDate(),
    Utils.GetEndDate(),
  ]);
  const [countryInfo, setCountryInfo] = useState({});
  const [isFollowUpOnlyMode, setIsFollowUpOnlyMode] = useState(false);
  const [statusFilter, setStatusFilter] = useState("");
  const [isFilterEnabled, setIsFilterEnabled] = useState(false);
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [localSettings, setLocalSettings] = useState({});
  const [userList, setUserList] = useState([]);
  const [selectedUserFilter, setSelectedUserFilter] = useState("");
  const [bulkFileName, setBulkFileName] = useState("");
  const [bulkLeadsList, setBulkLeadsList] = useState([]);
  const [openBulkLeads, setOpenBulkLeads] = useState(false);
  const [uploadedLeadsMobileNumbers, setUploadedLeadsMobileNumbers] = useState(
    []
  );
  const [bulkLeadsErrorOpen, setBulkLeadsErrorOpen] = useState(false);
  const [requiredBulkLeadColumns, setRequiredBulkLeadColumns] = useState([
    "CustomerName",
    "MobileNumber",
  ]);
  const [optionalBulkLeadColumns, setOptionalBulkLeadColumns] = useState([
    "Address",
    "Source",
    "Comments",
  ]);
  const [bulkLeadsTableColumns, setBulkLeadsTableColumns] = useState([
    "Index",
    "Customer Name",
    "Customer Address",
    "Mobile Number",
    "Source",
    "Comments",
  ]);
  const [uploadBulkLeadTableColumns, setUploadBulkLeadTableColumns] = useState([
    "rowIndex",
    "CustomerName",
    "Address",
    "MobileNumber",
    "Source",
    "Comments",
  ]);
  const fileInputRef = useRef(null);
  const [overallLeadsData, setOverallLeadsData] = useState([]);
  const [isAutomobileBusiness, setIsAutomobileBusiness] = useState(
    BusinessHelper.IsAutomobile()
  );
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);

  let startDTParam = Utils.GetStartDate(moment()),
      endDTParam = Utils.GetEndDate(moment());

   if (!Utils.IsNullOrEmptyObject(location.state)) {
      if (!Utils.IsNullOrEmpty(location.state.startDT)) {
          startDTParam = Utils.ConvertToDate(location.state.startDT);
        }
        if (!Utils.IsNullOrEmpty(location.state.endDT)) {
          endDTParam = Utils.ConvertToDate(location.state.endDT);
        }
   }

  useEffect(() => {
    const select = [startDTParam, endDTParam];
    let localSetting = connectToStore();
    if (UserHelper.CheckPermission(LeadDetailsPage, navigate)) {
      setCountryInfo(getCountry());
      getLeadDetails(select[0], select[1]);
      setSelectedDate(select);
      setLocalSettings(localSetting);
      if (BusinessHelper.IsAutomobile()) {
        setOptionalBulkLeadColumns([
          "Address",
          "Source",
          "Comments",
          "Make",
          "Model",
        ]);
        setBulkLeadsTableColumns([
          "Index",
          "Customer Name",
          "Customer Address",
          "Mobile Number",
          "Source",
          "Comments",
          "Make",
          "Model",
        ]);
        setUploadBulkLeadTableColumns([
          "rowIndex",
          "CustomerName",
          "Address",
          "MobileNumber",
          "Source",
          "Comments",
          "Make",
          "Model",
        ]);
      }
    }
  }, []);

  useEffect(() => {
    getUsers();
    getOverallLeadDetails();
  }, [localSettings]);

  const getUsers = async () => {
    if (localSettings.authenticated) {
      setIsLoading(true);
      let result = await postAsync(
        "Account/GetAccount",
        {},
        "",
        "GetAll",
        "AllUsersForBusiness",
        [localSettings.business.id]
      );
      if (!Utils.IsNullOrEmptyArray(result.data)) {
        setUserList(result.data);
      } else if (result.error) {
        setMsgOpen(true);
        setMsgText(result.errorMessage);
      }
      setIsLoading(false);
    }
  };

  const handleMsgClose = () => {
    setMsgOpen(false);
    if (isNavigateToLogin) {
      UserHelper.LogOut(dispatch);
      navigate(LoginPage.Path);
    }
    if (bulkLeadsErrorOpen) {
      setOpenBulkLeads(true);
      setBulkLeadsErrorOpen(false);
    }
    // fileInputRef.current.value = "";
  };

  const backNavigation = () => {
    navigate(OverviewPage.Path);
  };

  const getLeadDetails = async (startDT, endDT) => {
    setIsLoading(true);
    let localSetting = connectToStore();
    let response = null;
    response = await postAsync("lead/GetLeadDetailsByDate", {
      Start: Utils.GetISODateTimeString(startDT),
      End: Utils.GetISODateTimeString(endDT),
      BusinessId: localSetting.business.businessId,
      BranchId: localSetting.branch.branchId,
    });
    setIsNavigateToLogin(response.isNavigateToLogin);
    if (response.error) {
      setMsgOpen(true);
      setMsgText(response.errorMessage);
    } else {
      setLeadList(response.data);
      getOverallLeadDetails();
    }
    setIsLoading(false);
  };

  const SaveLeadsDetails = async (Details, isDeleteLead = false) => {
    setIsLoading(true);
    let localSetting = connectToStore();
    Details.branchId = localSetting.branch.branchId;
    Details.businessId = localSetting.business.businessId;
    Details.id = Utils.IsNullOrEmpty(editingLeadData) ? "" : editingLeadData.id;
    if(isDeleteLead) {
      Details.isDeletedLead = true;
    }

    let result = await postAsync(
      "lead/SaveLeadDetails",
      {
        BusinessId: getBusiness().id,
        LeadDetails: Details,
        NewIsLeadDetails: true,
      },
      "",
      "Execute",
      "",
      []
    );
    if (result.data === true) {
      getLeadDetails(selectedDate[0], selectedDate[1]);
      if(isDeleteLead) {
        setMsgText("Lead Details Deleted Successfully")
      } else {
        setMsgText("Lead Details Added Successfully");
      }
      setMsgOpen(true);
    } else {
      setMsgText("Unable to process your request");
      setMsgOpen(true);
    }
    setIsLoading(false);
  };

  const handleEditLead = (index, lead) => {
    setEditingLeadIndex(index);
    setEditingLeadData(lead);
    setShowLeadModal(true);
  };
  useEffect(() => {
    if (!Utils.IsNullOrEmptyArray(leadList)) {
      let _leads = leadList.filter((lead) => !lead?.isDeletedLead);
      if (isFilterEnabled) {
        _leads = _leads.filter((lead) => {
          const statusMatch = !statusFilter || lead.status === statusFilter;
          const userMatch =
            !selectedUserFilter || lead.selectedUserId === selectedUserFilter;
          return statusMatch && userMatch;
        });
      }
      setFilteredLeads(_leads);
    } else {
      setFilteredLeads([]);
    }
  }, [isFilterEnabled, statusFilter, leadList, selectedUserFilter]);

  const onDateChange = (date) => {
    if (!Utils.IsNullOrEmptyArray(date)) {
      var dateArray = [moment(date[0]), moment(date[1])];
      if (dateArray[0]._isValid == false || dateArray[1]._isValid == false) {
        setMsgText("Please select a valid date range.");
        setMsgOpen(true);
      } else {
        let dateDiff = dateArray[1].diff(dateArray[0], "days");
        if (dateDiff > MaxDateLimit) {
          setMsgText(
            "Please note that the maximum date range you can select is 90 days. You can choose any start date within the past 90 days, but the end date cannot exceed this limit."
          );

          setMsgOpen(true);
        } else {
          setSelectedDate(dateArray);
          getLeadDetails(dateArray[0], dateArray[1]);
        }
      }
    }
  };

  const handleAddBulkLead = () => {
    fileInputRef.current.click();
  };

  const isValidLength = (value) => {
    const maxLength = CountryHelper.GetMobileNumberMaxLength();
    const minLength = CountryHelper.GetMobileNumberMinLength();
    const len = String(value || "").trim().length;
    return len >= minLength && len <= maxLength;
  };

  const handleBulkFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setBulkFileName(file.name);
    const allErrors = [];
    let errorRows = [];

    // 1️⃣ File validation
    if (!/\.(xlsx|xls|csv)$/i.test(file.name)) {
      allErrors.push("Please upload a valid Excel file (.xlsx, .xls, or .csv)");
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

      if (json.length === 0) {
        allErrors.push("The Excel file is empty.");
      }

      // stop continuing if empty or invalid file
      if (allErrors.length > 0) {
        setMsgText(allErrors.join("<br><br>"));
        setMsgOpen(true);
        setBulkLeadsList([]);
        fileInputRef.current.value = "";
        return;
      }

      // 2️⃣ Column validation
      const fileColumns = Object.keys(json[0]);
      const missingRequired = requiredBulkLeadColumns.filter(
        (col) => !fileColumns.includes(col)
      );
      if (missingRequired.length > 0)
        allErrors.push(
          `Missing required columns: ${missingRequired.join(", ")}`
        );

      const allowedColumns = [
        ...requiredBulkLeadColumns,
        ...optionalBulkLeadColumns,
      ];
      const invalidColumns = fileColumns.filter(
        (col) => !allowedColumns.includes(col)
      );
      if (invalidColumns.length > 0)
        allErrors.push(`Invalid columns found: ${invalidColumns.join(", ")}`);

      // 3️⃣ Row-level validation
      const existingMobilesSet = new Set(
        uploadedLeadsMobileNumbers.map((num) => String(num).trim())
      );
      const mobileCount = {};

      json.forEach((row, index) => {
        const rowIndex = index + 1;
        const errors = [];
        const name = String(row["CustomerName"] || "").trim();
        const mobile = String(row["MobileNumber"] || "").trim();

        if (!name) errors.push("Missing Customer Name");
        if (!mobile) errors.push("Missing Mobile Number");

        if (mobile) {
          const isDigitsOnly = /^\d+$/.test(mobile);
          const isValidLen = isValidLength(mobile); // your helper
          if (!isDigitsOnly || !isValidLen)
            errors.push("Invalid Mobile Number format");

          if (!mobileCount[mobile]) mobileCount[mobile] = [];
          mobileCount[mobile].push(rowIndex);

          if (existingMobilesSet.has(mobile))
            errors.push("Mobile Number already exists in leads");
        }

        if (errors.length > 0) {
          errorRows.push({
            ...row,
            rowIndex,
            ErrorText: errors.join("\n"),
          });
        }
      });

      // 4️⃣ Detect duplicates within file
      Object.entries(mobileCount).forEach(([mobile, rows]) => {
        if (rows.length > 1) {
          rows.forEach((r) => {
            const existing = errorRows.find((x) => x.rowIndex === r);
            const duplicateText = `Duplicate Mobile Number found in rows: ${rows.join(
              ", "
            )}`;
            if (existing) {
              existing.ErrorText += `\n ${duplicateText}`;
            } else {
              const orig = json[r - 1];
              errorRows.push({
                ...orig,
                rowIndex: r,
                ErrorText: duplicateText,
              });
            }
          });
        }
      });

      if (errorRows.length > 0) {
        allErrors.push(
          `Found ${errorRows.length} row(s) with issues in upload file.`
        );
      }

      // 5️⃣ Final handling
      if (allErrors.length > 0) {
        setMsgText(allErrors.join("\n\n")); // 🔹 nicely spaced message
        setMsgOpen(true);
        setBulkLeadsErrorOpen(true);
        setBulkLeadsList(errorRows);
        fileInputRef.current.value = "";
      } else {
        setBulkLeadsList(json);
        UploadBulkLeads(json);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const UploadBulkLeads = async (bulkLeadsList) => {
    setIsLoading(true);
    let result = await postAsync(
      "lead/SaveBulkLeadDetails",
      {
        BusinessId: localSettings.business.id,
        BulkLeadDetails: bulkLeadsList,
        BranchId: localSettings.branch.branchId,
      },
      "",
      "Execute",
      "",
      []
    );
    if (result.error) {
      setMsgOpen(true);
      setMsgText(result.errorMessage);
    } else if (result.data) {
      getLeadDetails(selectedDate[0], selectedDate[1]);
      setMsgText("Bulk Lead Details Uploaded Successfully");
      setMsgOpen(true);
    }
    fileInputRef.current.value = ""; // empty bulk input filed
    setIsLoading(false);
  };

  const closeBulkLeads = () => {
    setOpenBulkLeads(false);
    setBulkLeadsList(false);
    setBulkFileName("");
    fileInputRef.current.value = "";
  };

  const handleDownloadLeadTemplate = () => {
    const link = document.createElement("a");
    if (isAutomobileBusiness) {
      link.href =
        "https://infopointblobstorage.blob.core.windows.net/templates/AutoMobileBulkLeadUploadTemplate.xlsx";
    } else {
      link.href =
        "https://infopointblobstorage.blob.core.windows.net/templates/SaloonBulkLeadUploadTemplate.xlsx";
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setMsgOpen(true);
    setMsgText("Template has been downloaded successfully.<br><br><b>CustomerName</b> and <b>MobileNumber</b> are mandatory fields.")
  };

  const getOverallLeadDetails = async () => {
    if (!Utils.IsNullOrEmptyObject(localSettings)) {
      setIsLoading(true);
      let result = await postAsync(
        "Lead/GetLeadDetails",
        {},
        "",
        "GetAll",
        "GetAllVendorDetailsByBusiness",
        [localSettings.business.id]
      );
      if (result.error) {
        setMsgOpen(true);
        setMsgText(result.errorMessage);
      } else {
        if (!Utils.IsNullOrEmptyArray(result.data)) {
          let overallData = result.data.filter((item) => !item?.isDeletedLead);
          setOverallLeadsData(overallData);
          const mobileNumberList = overallData.map(
            (item) => item.mobileNumber
          );
          setUploadedLeadsMobileNumbers(mobileNumberList);
        }
      }
      setIsLoading(false);
    }
  };

  const handleDeleteLead = (index, lead) => {
    setEditingLeadIndex(index);
    setEditingLeadData(lead);
    setShowCancelConfirmation(true);
    setBulkLeadsErrorOpen(false);
  }

  const confirmCancel = async (confirmResult) => {
    setShowCancelConfirmation(false);
    switch (confirmResult) {
      case ConfirmTypes.YES:
        SaveLeadsDetails(editingLeadData,true);
      default:
        return;
    }
  }

  return (
    <Container maxWidth="false" className="bg-color p-0">
      <Grid className="container">
        <Loader open={isLoading} />
        <MessagePopup
          msgOpen={msgOpen}
          msgText={msgText}
          onMsgClose={handleMsgClose}
        />
        <ConfirmDialog
                  open={showCancelConfirmation}
                  onClose={confirmCancel}
                  message="Are you sure you want to delete this lead?"
                  yesText="Yes"
                  noText="No"
                />
        <AddLeadsDetails
          open={showLeadModal}
          onClose={() => {
            setIsFollowUpOnlyMode(false);
            setShowLeadModal(false);
            setEditingLeadIndex(null);
            setEditingLeadData(null);
          }}
          onSubmit={SaveLeadsDetails}
          initialValues={editingLeadData}
          followUpOnly={isFollowUpOnlyMode}
          userList={userList}
        />
        <Box>
          {/* Bulk Leads Error Dialog */}
          <ErrorTableDialog
            open={openBulkLeads}
            onClose={closeBulkLeads}
            title="Errors"
            tableColumns={bulkLeadsTableColumns}
            uploadColumns={uploadBulkLeadTableColumns}
            dataList={bulkLeadsList}
          />
          <Grid container m={0}>
            <SideBarMenuItems selectedTab={SideBarMenuNames.Overview} />
            <Grid
              item
              xs={12}
              className="content-sec"
              sx={{ paddingBottom: "100px" }}
            >
              <Grid container direction="row" className="">
                <Grid
                  container
                  className="title-sec"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  {/* Left side: Add Lead Button */}
                  <Grid item>
                    <Stack direction="row" alignItems="center" spacing={2}>
                      <Button onClick={backNavigation} className="back-btn">
                        <NavigateBeforeIcon />
                      </Button>
                      <Typography
                        component="h2"
                        fontWeight="600"
                        fontSize="2rem"
                      >
                        Leads Dashboard {filteredLeads.length && `- ${filteredLeads.length}`}
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid item>
                    <Stack
                      direction="row"
                      spacing={2}
                      alignItems="center"
                      className="font-size-14"
                    >
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography variant="body2">Filter</Typography>
                        <Switch
                          checked={isFilterEnabled}
                          onChange={(e) => {
                            setIsFilterEnabled(e.target.checked);
                            setStatusFilter("");
                            setSelectedUserFilter("");
                          }}
                          color="primary"
                        />
                      </Stack>
                      {isFilterEnabled && (
                        <FormControl
                          size="small"
                          sx={{ minWidth: 200 }}
                          variant="outlined"
                        >
                          <InputLabel id="status-filter-label">
                            Status Filter
                          </InputLabel>
                          <Select
                            labelId="status-filter-label"
                            label="Status Filter"
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            input={
                              <OutlinedInput
                                label="Status Filter"
                                endAdornment={
                                  statusFilter && (
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation(); // prevent opening dropdown
                                        setStatusFilter("");
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )
                                }
                              />
                            }
                          >
                            {Object.entries(LeadStatus).map(([key, value]) => (
                              <MenuItem key={key} value={value}>
                                {value}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}

                      {isFilterEnabled && (
                        <FormControl
                          size="small"
                          sx={{ minWidth: 200 }}
                          variant="outlined"
                        >
                          <InputLabel id="user-filter-label">
                            User Filter
                          </InputLabel>
                          <Select
                            labelId="user-filter-label"
                            label="User Filter"
                            value={selectedUserFilter}
                            onChange={(e) =>
                              setSelectedUserFilter(e.target.value)
                            }
                            input={
                              <OutlinedInput
                                label="User Filter"
                                endAdornment={
                                  selectedUserFilter && (
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation(); // prevent opening dropdown
                                        setSelectedUserFilter("");
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )
                                }
                              />
                            }
                          >
                            {userList
                              .filter(
                                (user) =>
                                  user.role !== "GlobalAdmin" &&
                                  user.role !== "BranchAdmin"
                              )
                              .map((user) => (
                                <MenuItem key={user.id} value={user.id}>
                                  {user.firstName ?? ""}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      )}

                      <Stack direction="column" spacing={1} alignItems="end">
                        <DateRangePicker
                          showLeadingZeros
                          onChange={onDateChange}
                          maxDate={addMonths(new Date(), +3)}
                          value={selectedDate}
                          locale={CountryHelper.GetDateCulture(
                            countryInfo.Culture
                          )}
                          clearIcon={null}
                          calendarIcon={
                            <CalendarMonthOutlinedIcon
                              style={{
                                fontSize: "24px",
                                alignSelf: "center",
                                color: "#666666",
                              }}
                            />
                          }
                        />

                        <Button
                          variant="contained"
                          className="btn btn-primary"
                          onClick={() => setShowLeadModal(true)}
                        >
                          + Add Lead
                        </Button>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>

                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  spacing={2}
                >
                  <input
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleBulkFileChange}
                  />
                  <Grid item>
                    <Button
                      size="small"
                      variant="contained"
                      className="btn btn-primary"
                      onClick={handleAddBulkLead}
                    >
                      Upload Leads
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      size="small"
                      variant="contained"
                      className="btn btn-secondary"
                      startIcon={<DownloadIcon />}
                      onClick={handleDownloadLeadTemplate}
                    >
                      Template
                    </Button>
                  </Grid>
                </Grid>

                {/* Lead Cards Section */}

                <Grid
                  container
                  spacing={2}
                  sx={{ mt: 2 }}
                  className="font-size-14"
                >
                  {filteredLeads.map((lead, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                      <Card
                        variant="outlined"
                        sx={{ p: 2, borderRadius: 2, boxShadow: 1 }}
                        onClick={() => {
                          setShowLeadModal(true);
                          setIsFollowUpOnlyMode(true);
                          setEditingLeadIndex(null);
                          setEditingLeadData(lead);
                        }}
                      >
                        <CardContent>
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Typography
                              variant="h6"
                              fontWeight={600}
                              gutterBottom
                            >
                              {lead.customerName}
                            </Typography>

                            <Chip
                              label={lead.status}
                              size="small"
                              sx={{
                                backgroundColor:
                                  lead.status === LeadStatus.HotLead
                                    ? "#ffebee"
                                    : lead.status === LeadStatus.ClosedLead
                                    ? "#e0e0e0"
                                    : lead.status === LeadStatus.ActiveLead
                                    ? "#e8f5e9"
                                    : "#eeeeee",
                                color:
                                  lead.status === LeadStatus.HotLead
                                    ? "#d32f2f"
                                    : lead.status === LeadStatus.ClosedLead
                                    ? "#616161"
                                    : lead.status === LeadStatus.ActiveLead
                                    ? "#388e3c"
                                    : "#424242",
                                fontWeight: 600,
                              }}
                            />
                          </Stack>

                          {lead.nextFollowUpDT && (
                            <Typography
                              variant="subtitle2"
                              color="primary"
                              gutterBottom
                            >
                              📅 Next Follow-Up:{" "}
                              {moment(lead.nextFollowUpDT).format(
                                "DD MMM YYYY"
                              )}
                            </Typography>
                          )}

                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            sx={{ mb: 0.5 }}
                          >
                            <Typography variant="body2">📞</Typography>
                            <Typography variant="body2">
                              {lead.mobileNumber}
                            </Typography>
                          </Stack>

                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            sx={{ mb: 0.5 }}
                          >
                            <Typography variant="body2">🏠</Typography>
                            <Typography variant="body2">
                              {lead.address}
                            </Typography>
                          </Stack>

                          {BusinessHelper.GetBusinessCategory() ===
                            BusinessCategories.Automobile && (
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems="center"
                              sx={{ mb: 0.5 }}
                            >
                              <Typography variant="body2">🚗</Typography>
                              <Typography variant="body2">
                                {lead.make} - {lead.model}
                              </Typography>
                            </Stack>
                          )}
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="baseline"
                            sx={{ mb: 0.5 }}
                          >
                            <Typography
                              sx={{ minWidth: "120px" }}
                              variant="subtitle2"
                            >
                              📝 Commitments:
                            </Typography>
                            <Typography variant="body2">
                              {lead.comments}
                            </Typography>
                          </Stack>
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="baseline"
                            sx={{ mb: 0.5 }}
                          >
                            <Typography variant="subtitle2">
                              {" "}
                              👤 User:
                            </Typography>
                            <Typography variant="body2">
                              {userList.find(
                                (user) => user.id === lead.selectedUserId
                              )?.firstName ?? "-"}
                            </Typography>
                          </Stack>
                        </CardContent>

                        <CardActions sx={{ justifyContent: "flex-end" }}>
                          {localSettings.user.role === UserRoles.GlobalAdmin && <Button
                            size="small"
                            variant="outlined"
                            sx={{color: "red", borderColor: "red",
                              "&:hover": {
                                borderColor: "red", 
                                backgroundColor: "rgba(255, 0, 0, 0.04)", 
                              },
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteLead(index, lead);
                            }}
                          >
                            Delete
                          </Button>}
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditLead(index, lead);
                            }}
                          >
                            Follow-Up
                          </Button>
                        </CardActions>
                      </Card>
                    </Grid>
                  ))}
                  {filteredLeads.length === 0 && (
                    <Typography variant="body2" sx={{ mt: 2 }}>
                      No leads found for selected status.
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Container>
  );
};

export default LeadDetails;
